import * as React from 'react'
import { DeleteAndConfirmWidget } from './DeleteAndConfirmWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DeleteAndConfirmWidgetExamples = () => {
  return (
    <div className="DeleteAndConfirmWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DeleteAndConfirmWidget />
      </Provider>
    </div>
  )
}
